// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2yNyF","rootSuccess":"CompleteLink_rootSuccess__2y4PV","rootFailure":"CompleteLink_rootFailure__MufmA","isDisabled":"CompleteLink_isDisabled__vmYH4"};